

function SelectTypeContent({ optionsState, selectedOption }) {
    return (
        <div className="flex flex-row-reverse items-center mb-5">
            <p className="w-28 text-right"> : نوع محتوا</p>
            <select
                className="bg-white border border-slate-200 p-1 w-2/5 text-right rounded drtl"
                value={optionsState}
                onChange={selectedOption}
            >
                <option value="" className="text-right">انتخاب کنید</option>
                <option value="متن" className="text-right">متن</option>
                <option value="تصویر" className="text-right">تصویر</option>
                <option value="ویدیو" className="text-right">ویدیو</option>
                <option value="فایل صوتی" className="text-right">فایل صوتی</option>
                <option value="فایل" className="text-right">فایل</option>
            </select>
        </div>
    )
}
export default SelectTypeContent;